import { render, staticRenderFns } from "./ModalIssues.vue?vue&type=template&id=44117e5e&scoped=true"
import script from "./ModalIssues.vue?vue&type=script&lang=js"
export * from "./ModalIssues.vue?vue&type=script&lang=js"
import style0 from "./ModalIssues.vue?vue&type=style&index=0&id=44117e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44117e5e",
  null
  
)

export default component.exports